<script lang="ts" setup>
// @ts-ignore
import { SplideSlide } from '@splidejs/vue-splide'

export interface ProducstListProps {
    headingLevel: string
    bestsellers: {
        data: ProductBox[]
        title: string
    }
    products: {
        data: ProductBoxSimple[]
        title: string
    }
    otherProducts: string
}

const props = defineProps<ProducstListProps>()

const getProductSimpleLink = (product: ProductBoxSimple): VNuxtLinkTo => {
    if (product.meta_product) {
        return {
            name: product.slug,
        }
    }
    const productLink = useProductLink(product.slug)

    return {
        name: 'insurance-detail',
        params: {
            category: productLink.categoryId,
            id: productLink.productId,
        },
    }
}
</script>

<template>
  <section data-cy="widget_products">
    <Tracker :data="{ position: props.bestsellers.title }">
      <Box
        color="yellow"
        decor-position="top-left"
        padding="px-2 py-10 px-lg-6 py-lg-15"
        class="rounded"
      >
        <heading
          :level="props.headingLevel"
          class="text-center alfa mb-4 mb-md-9"
        >
          {{ props.bestsellers.title }}
        </heading>
        <Slider>
          <SplideSlide
            v-for="(product, index) in props.bestsellers.data"
            :key="index"
          >
            <ProductBox
              class="h-100"
              :item="product"
              heading-level="h3"
            />
          </SplideSlide>
        </Slider>
        <aside v-if="props.products.data.length">
          <h3 class="mb-4 mb-md-2 mt-10 beta text-center">
            {{ props.otherProducts }}
          </h3>
          <div class="row justify-content-center">
            <div
              v-for="(productSimple, index) in props.products
                .data"
              :key="index"
              class="translate-y-hover-wrapper col-12 col-md-6 col-lg-4 mt-2 mt-md-6"
            >
              <ProductBoxSimple
                :title="productSimple.title"
                :to="getProductSimpleLink(productSimple)"
              />
            </div>
          </div>
        </aside>
      </Box>
    </Tracker>
  </section>
</template>
